'use strict';

var react = require('react');

function useCombinedRefs(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return react.useCallback((value) => setRefs(value, refs), refs);
}
function setRefs(value, refs) {
    for (const ref of refs) {
        if (typeof ref === 'function') {
            ref(value);
        }
        else if (ref) {
            ref.current = value;
        }
    }
}

exports.setRefs = setRefs;
exports.useCombinedRefs = useCombinedRefs;
//# sourceMappingURL=useCombinedRefs.js.map
